import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import { SpinnerThirdSolidV6 } from "@shared/v2/Icomoon";
import PopularCard from "./shared/PopularCard";

const RecruiterAiPopular = ({ hasSubscription }) => (
  <PopularCard
    title="Recruiter.AI"
    description="Revolutionize Real Estate recruiting with AI innovation! Leverage the power of Brivity to post open positions, plus qualify and nurture candidates in minutes."
  >
    <Button
      size="medium"
      onClick={() => {
        if (hasSubscription) {
          window.open("/launch?slug=brivity-recruiter", "_blank");
        } else {
          window.open("/launch?slug=brivity-recruiter&redirectPath=/recruiter%3FshowSignUp%3Dtrue", "_blank");
        }
      }}
    >
      {hasSubscription ? "Launch" : "Purchase"}
    </Button>
    <div
      className="tw-absolute tw-top-[60px] tw-right-[35px] tw-w-[364px] tw-h-[240px] tw-rounded-[10px] tw-bg-white tw-shadow-card"
      style={{
        background: "url(/images/bg-addon-popular-recruiter-graph.jpg) center center/cover no-repeat",
      }}
    />
    <div className="tw-absolute tw-right-[23px] tw-top-0 tw-flex tw-gap-[6px] tw-items-baseline tw-px-[20px] tw-py-[29px] tw-rounded-[10px] tw-bg-white tw-shadow-card">
      <span className="tw-text-theme-primary tw-block tw-text-[38px] tw-leading-none">+150</span>
      <span className="tw-text-gray-50 tw-text-[20px] tw-leading-none">Candidates</span>
    </div>
    <div className="tw-absolute tw-left-0 tw-bottom-[53px] tw-flex tw-flex-col tw-items-center tw-w-[295px] tw-p-[18px] tw-rounded-[10px] tw-bg-white tw-shadow-card">
      <SpinnerThirdSolidV6 className="tw-mb-[15px]" />
      <div className="tw-w-full tw-px-[16px] tw-mb-[8px]">
        <div className="tw-relative tw-bg-neutral-gray-10 tw-overflow-hidden tw-rounded-[8px] tw-h-[8px]">
          <div className="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-1/2 tw-bg-theme-primary tw-rounded-[8px]" />
        </div>
      </div>
      <span>Generating new summary with AI....</span>
    </div>
  </PopularCard>
);

RecruiterAiPopular.propTypes = {
  hasSubscription: PropTypes.bool,
};

RecruiterAiPopular.defaultProps = {
  hasSubscription: false,
};

export default RecruiterAiPopular;
